var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 4.93 8.39"}},[_c('polygon',{attrs:{"points":"4.22 8.39 0 4.17 4.17 0 4.88 0.71 1.41 4.17 4.93 7.69 4.22 8.39"}})])}
var staticRenderFns = []

export { render, staticRenderFns }